<script setup lang="ts">
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";
import loaderSrc from "@/assets/loader.lottie";

interface Props {
  title?: string;
  description?: string;
  src?: string;
  fullscreen?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  title: undefined,
  description: undefined,
  src: undefined,
  fullscreen: false,
});

const source = props.src ?? loaderSrc;
</script>

<template>
  <div class="pj-loading" :class="{ 'pj-loading--fullscreen': fullscreen }">
    <div class="pj-loading__inner">
      <DotLottieVue class="pj-loading__animation" autoplay loop :src="source" />
      <p v-if="title" class="pj-loading__title">{{ title }}</p>
      <p v-if="description" class="pj-loading__description">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pj-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 200px;
  padding: var(--pj-space-4);
}

.pj-loading--fullscreen {
  min-height: 100dvh;
}

.pj-loading__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--pj-space-2);
}

.pj-loading__animation {
  width: 200px;
  height: 200px;
}

.pj-loading__title {
  margin: 0;
  font-family: var(--pj-font-family-sans);
  font-size: var(--pj-font-size-base);
  font-weight: var(--pj-font-weight-medium);
  line-height: var(--pj-font-line-height-base);
  color: var(--pj-color-brand-gray-850, #222926);
}

.pj-loading__description {
  margin: 0;
  font-family: var(--pj-font-family-sans);
  font-size: var(--pj-font-size-sm);
  font-weight: var(--pj-font-weight-regular);
  line-height: var(--pj-font-line-height-base);
  color: var(--pj-color-brand-gray-550, #74756f);
}
</style>
